import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuStateService {
  private menuState = new BehaviorSubject<boolean>(true);
  menuState$ = this.menuState.asObservable();

  toggleMenu(state: boolean): void {
    this.menuState.next(state);
  }
}